
export default {
  name: "ProductCardSmallImage",

  props: {
    product: {
      type: Object,
      default: () => {
        return {}
      }
    }
  },

  computed: {
    seoTitle: function () {
      return this.product?.dynamicFields?.seo_title || ""
    }
  }
}
